/**
 * When the client already sent targetStrategem for a strategem instance, a delayed
 * turn-played/game-update can still carry needsStrategemTarget from the earlier playOrder.
 * Strip that stale flag so syncStrategemTargeting does not reopen targeting UI.
 */
function resolvePlayerStateKey(gameState, playerId) {
  if (!gameState?.state || playerId == null) return null;
  if (gameState.state[playerId]) return playerId;
  const pid = String(playerId);
  return Object.keys(gameState.state).find((key) => String(key) === pid) ?? null;
}

export function stripStaleSubmittedStrategemNeeds(gameState, playerId, submittedInstanceId) {
  if (!gameState?.state || !submittedInstanceId) {
    return gameState;
  }
  const playerKey = resolvePlayerStateKey(gameState, playerId);
  if (!playerKey) {
    return gameState;
  }
  const needs = gameState.state[playerKey]?.needsStrategemTarget;
  if (!needs?.strategemInstanceId) {
    return gameState;
  }
  if (String(needs.strategemInstanceId) !== String(submittedInstanceId)) {
    return gameState;
  }
  const next = JSON.parse(JSON.stringify(gameState));
  delete next.state[playerKey].needsStrategemTarget;
  return next;
}

export default stripStaleSubmittedStrategemNeeds;
